import { fromJS } from 'immutable'; // import { ALERT_TYPE } from '../consts/alert'

export var SET_ALERT = 'global/SET_ALERT';
export var SET_ALARM_SOUND_ON = 'global/SET_ALARM_SOUND_ON';
export var SET_ALARM_SOUND_PAUSED = 'global/SET_ALARM_SOUND_PAUSED';
export var SET_ALARM_LIST = 'global/SET_ALARM_LIST';
export var SET_DISCONNECTED_CAMERA_LIST = 'global/SET_DISCONNECTED_CAMERA_LIST';
export var SET_SCREEN_CART_CAMERA_LIST = 'global/SET_SCREEN_CART_CAMERA_LIST';
export var SET_ZONESLIST = 'global/SET_ZONESLIST';
export var SET_ZONESLIST_DATA = 'global/SET_ZONESLIST_DATA';
export var SET_TERMINALSLIST = 'global/SET_TERMINALSLIST';
export var SET_ALL_TERMINALSLIST = 'global/SET_ALL_TERMINALSLIST';
export var SET_LOGISTICSLIST = 'global/SET_LOGISTICSLIST';
export var SET_ALL_LOGISTICSLIST = 'global/SET_ALL_LOGISTICSLIST';
export var SET_GATE_LIST = 'global/SET_GATE_LIST';
export var SET_OPEN_TRAFFICLIVE_TAB = 'global/SET_OPEN_TRAFFICLIVE_TAB';
export var SET_OPEN_SIDE_MENU = 'global/SET_OPEN_SIDE_MENU';
export var SET_IS_MOBILE_DEVICE = 'global/SET_IS_MOBILE_DEVICE';
export var SET_MARQUEES_DATA = 'global/SET_MARQUEES_DATA';
export var SET_BILLBOARD_TYPE_LIST = 'global/SET_BILLBOARD_TYPE_LIST';
export var SET_AUDIT_LOG_ERROR = 'global/SET_AUDIT_LOG_ERROR';
export var SET_FEEDBACK_DESCRIPTION = 'global/SET_FEEDBACK_DESCRIPTION';
/**
 * Sets global alert message.
 * @param {ALERT_TYPE} [status] The error type. Defaults to ALERT_TYPE.ERROR
 * @param {string} [data] The error message. Pass null to clear display.
 */

var ALERT_TYPE = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  SUCCESS: 'success'
};
export function setAlert() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ALERT_TYPE.ERROR;
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    type: SET_ALERT,
    status: status,
    data: data
  };
}
export function setAlarmSoundOn(alarmSoundOn) {
  return {
    type: SET_ALARM_SOUND_ON,
    alarmSoundOn: alarmSoundOn
  };
}
export function setAlarmSoundPaused(alarmSoundPaused) {
  return {
    type: SET_ALARM_SOUND_PAUSED,
    alarmSoundPaused: alarmSoundPaused
  };
}
export function setAlarmList(alarmList) {
  return {
    type: SET_ALARM_LIST,
    alarmList: alarmList
  };
}
export function setDisconnectedCameraList(disconnectedCameraList) {
  return {
    type: SET_DISCONNECTED_CAMERA_LIST,
    disconnectedCameraList: disconnectedCameraList
  };
}
export function setScreenCartCameraList(screenCartCameraList) {
  return {
    type: SET_SCREEN_CART_CAMERA_LIST,
    screenCartCameraList: screenCartCameraList
  };
}
export var setZonesList = function setZonesList(data) {
  return {
    type: SET_ZONESLIST,
    data: data
  };
};
export var setZonesListData = function setZonesListData(data) {
  return {
    type: SET_ZONESLIST_DATA,
    data: data
  };
};
export var setTerminalsList = function setTerminalsList(data) {
  return {
    type: SET_TERMINALSLIST,
    data: data
  };
};
export var setAllTerminalsList = function setAllTerminalsList(data) {
  return {
    type: SET_ALL_TERMINALSLIST,
    data: data
  };
};
export var setLogisticsList = function setLogisticsList(data) {
  return {
    type: SET_LOGISTICSLIST,
    data: data
  };
};
export var setAllLogisticsList = function setAllLogisticsList(data) {
  return {
    type: SET_ALL_LOGISTICSLIST,
    data: data
  };
};
export var setGateList = function setGateList(data) {
  return {
    type: SET_GATE_LIST,
    data: data
  };
};
export var setOpenTrafficLiveTab = function setOpenTrafficLiveTab(data) {
  return {
    type: SET_OPEN_TRAFFICLIVE_TAB,
    data: data
  };
};
export var setOpenSideMenu = function setOpenSideMenu(data) {
  return {
    type: SET_OPEN_SIDE_MENU,
    data: data
  };
};
export var setIsMobileDevice = function setIsMobileDevice(data) {
  return {
    type: SET_IS_MOBILE_DEVICE,
    data: data
  };
};
export var setMarqueesData = function setMarqueesData(data) {
  return {
    type: SET_MARQUEES_DATA,
    data: data
  };
};
export var setBillboardTypeList = function setBillboardTypeList(data) {
  return {
    type: SET_BILLBOARD_TYPE_LIST,
    data: data
  };
};
export var setAuditLogError = function setAuditLogError(data) {
  return {
    type: SET_AUDIT_LOG_ERROR,
    data: data
  };
};
export var setFeedbackDescription = function setFeedbackDescription(data) {
  return {
    type: SET_FEEDBACK_DESCRIPTION,
    data: data
  };
};
var initialState = fromJS({
  error: {
    message: '',
    display: false
  },
  warn: {
    message: '',
    display: false
  },
  info: {
    message: '',
    display: false
  },
  success: {
    message: '',
    display: false
  },
  alarmSoundOn: false,
  alarmSoundPaused: false,
  alarmList: [],
  disconnectedCameraList: [],
  screenCartCameraList: JSON.parse(localStorage.getItem('screenCartCameraList') || '[]'),
  // zones detail data
  zonesListData: [],
  // dropdown list
  zonesList: [],
  terminalsList: [],
  allTerminalsList: [],
  logisticsList: [],
  allLogisticsList: [],
  gateList: [],
  openTrafficLiveTab: true,
  openSideMenu: true,
  isMobileDevice: false,
  marqueesData: [],
  billboardTypeList: [],
  auditLogError: false,
  feedbackDescription: ''
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SET_ALERT:
      if (!action.data) {
        return state.withMutations(function (s) {
          s.setIn([action.status, 'message'], '');
          s.setIn([action.status, 'display'], false);
        });
      } else {
        return state.withMutations(function (s) {
          s.setIn([action.status, 'message'], '');
          s.setIn([action.status, 'display'], true);
        });
      }

    case SET_ALARM_SOUND_ON:
      return state.set('alarmSoundOn', action.alarmSoundOn);

    case SET_ALARM_SOUND_PAUSED:
      return state.set('alarmSoundPaused', action.alarmSoundPaused);

    case SET_ALARM_LIST:
      return state.set('alarmList', action.alarmList);

    case SET_DISCONNECTED_CAMERA_LIST:
      return state.set('disconnectedCameraList', action.disconnectedCameraList);

    case SET_SCREEN_CART_CAMERA_LIST:
      {
        try {
          var serialized = JSON.stringify(action.screenCartCameraList);
          localStorage.setItem('screenCartCameraList', serialized);
        } catch (err) {
          console.log('Unable to use localStorage to store screenCartCameraList.');
        }

        return state.set('screenCartCameraList', action.screenCartCameraList);
      }

    case SET_ZONESLIST:
      return state.set('zonesList', action.data);

    case SET_ZONESLIST_DATA:
      return state.set('zonesListData', action.data);

    case SET_TERMINALSLIST:
      return state.set('terminalsList', action.data);

    case SET_ALL_TERMINALSLIST:
      return state.set('allTerminalsList', action.data);

    case SET_LOGISTICSLIST:
      return state.set('logisticsList', action.data);

    case SET_ALL_LOGISTICSLIST:
      return state.set('allLogisticsList', action.data);

    case SET_GATE_LIST:
      return state.set('gateList', action.data);

    case SET_OPEN_TRAFFICLIVE_TAB:
      return state.set('openTrafficLiveTab', action.data);

    case SET_OPEN_SIDE_MENU:
      return state.set('openSideMenu', action.data);

    case SET_IS_MOBILE_DEVICE:
      return state.set('isMobileDevice', action.data);

    case SET_MARQUEES_DATA:
      return state.set('marqueesData', action.data);

    case SET_BILLBOARD_TYPE_LIST:
      return state.set('billboardTypeList', action.data);

    case SET_AUDIT_LOG_ERROR:
      return state.set('auditLogError', action.data);

    case SET_FEEDBACK_DESCRIPTION:
      return state.set('feedbackDescription', action.data);

    default:
      return state;
  }
}